<template>
  <h2 class="sm:text-2xl text-xl font-bold text-gray-900 mb-6">
    <slot />
  </h2>
</template>
